<template>
  <div id="toy">
    <!--顶部选项-->
    <div class="topShell">
      <ul class="top">
        <span :class="{active:see == 'zuojia'}" @click="see = 'zuojia'">座驾</span>
        <span :class="{active:see == 'lianghao'}" @click="see = 'lianghao'">靓号</span>
      </ul>
    </div>

    <!--座驾/靓号商城-->
    <toyzuojia :type="see" :list="list" @upgrade="getInfo" />

    <!--头像区域-->
    <div class="bottom flex-box relativeItem">
      <img :src="info.avatar" class="head" />
      <img src="../../assets/icon (20).png" class="sign" />
      <span>{{ info.balance }}</span>
      <div class="button flex-box absoluteItem centerY">
        <div class="my radius3 relativeItem">
          <router-link to="/myStagePro" class="allA"></router-link>我的道具
        </div>
        <div class="recharge radius3 commonBk relativeItem">
          <a class="allA" v-if="minipro" @click="to_mini_recharge"></a>
          <router-link to="/recharge" class="allA" v-else></router-link>去充值
        </div>
      </div>
    </div>

    <!--空白内容提示组件-->
    <blank message="这里是空白" v-if="showBlank"></blank>
  </div>
</template>

<script>
import blank from "../me/blank";
import toyzuojia from "./toy-zuojia";

export default {
  name: "toy",
  components: {
    blank,
    toyzuojia
  },
  data() {
    return {
      minipro: false,
      info: [],
      showBlank: false, //显示空白组件
      see: "zuojia",
      list: [], //传给组件的列表
      zuojia_list: [], //座驾
      liang_list: [] //靓号
    };
  },
  methods: {
    //前往小程序的充值中心
    to_mini_recharge() {
      this.$wx.miniProgram.navigateTo({
        url: "/pages/recharge/recharge"
      });
    },
    //获取个人信息
    getInfo() {
      let _this = this;
      let data = {};
      this.$jsonp(this.$apis("me"), data, res => {
        _this.info = res.data.data.result;
      });
    },
    /**获取道具列表 */
    get_zuojia_toy() {
      let _this = this;
      this.$jsonp(this.$apis("toylist"), {type:"1"}, res => {
        if (res.data.ret == 200 && res.data.data.result.list.length != 0) {
          _this.zuojia_list = res.data.data.result.list;
          _this.list = _this.zuojia_list;
        } else {
          _this.list = [];
          _this.showBlank = true;
        }
      });
    },
    /**获取靓号列表 */
    get_liang_toy() {
      let _this = this;
      this.$jsonp(this.$apis("toylist"), {type:"0"}, res => {
        if (res.data.ret == 200 && res.data.data.result.list.length != 0) {
          _this.liang_list = res.data.data.result.list;
          _this.list = _this.liang_list;
        } else {
          _this.list = [];
          _this.showBlank = true;
        }
      });
    }
  },
  mounted: function() {
    this.$tool.setTitle("商城");
    this.$emit("showOhidden", false, 3);
    this.get_zuojia_toy();
    this.getInfo();
    //判断是否在小程序里
    let _this = this;
    _this.$tool.is_mini().then(function(res) {
      _this.minipro = res;
    });
  },
  watch: {
    see(val) {
      this.showBlank = false;
      if (val == "zuojia") {
        if (this.zuojia_list.length == 0) {
          this.get_zuojia_toy();
        } else {
          this.list = this.zuojia_list;
        }
      } else {
        if (this.liang_list.length == 0) {
          this.get_liang_toy();
        } else {
          this.list = this.liang_list;
        }
      }
    }
  }
};
</script>








<style scoped lang="scss">
/*底部头像区域*/
#toy {
  padding-top: 2.2rem;
}
.bottom {
  background: #f4f4f4;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 3;
  padding: 0.8rem 1rem;
  align-items: center;
  .head {
    width: 1.875rem;
    height: 1.875rem;
    border-radius: 50%;
    margin-right: 0.7rem;
  }
  .sign {
    width: 1rem;
    height: 1rem;
    margin-right: 5px;
  }

  .button {
    right: 0.8rem;
    align-items: center;
    div {
      font-size: 12px;
      padding: 0.375rem 1rem;
    }
    .my {
      color: #999;
      border: 1px solid #999;
      margin-right: 0.6rem;
    }
    .recharge {
      color: #fff;
    }
  }
}
</style>
